export const SET_APPS = 'SET_APPS'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_SERVICES = 'SET_SERVICES'
export const SET_PROVIDERS = 'SET_PROVIDERS'
export const SET_STATUSES = 'SET_STATUSES'
export const SET_AUTH = 'SET_AUTH'